/* Tilkøb-boks på produktsider – se snippets/bh-tilkoeb.liquid */
(function () {
  var box = document.querySelector('[data-bh-tk]');
  if (!box || box.dataset.klar) return;
  box.dataset.klar = '1';

  // Placér boksen før "Husk også"-boksen (plejemidler/lagner), ellers hvor temaets "Tilkøb"-blok står.
  // Temaets egen "Tilkøb"-blok skjules.
  // Er der også en "Husk også"-boks, samles de to til én boks (Tilkøb øverst, Husk nederst).
  function placer() {
    var blok = document.querySelector('.product__block--complementary');
    var husk = document.querySelector('[data-husk-ogsaa]');
    var huskBlok = husk && (husk.closest('.product__block') || husk);
    var foer = huskBlok || blok;
    if (foer && foer.parentElement) foer.parentElement.insertBefore(box, foer);
    if (blok) blok.style.display = 'none';
    // Links der scroller til temaets tilkøb (fx "Se sengegavle her") skal ramme denne boks i stedet
    omdirigerLinks();
    if (husk) {
      box.appendChild(husk);
      box.classList.add('bh-tk--samlet');
      if (huskBlok !== husk && !huskBlok.querySelector(':scope > :not(script):not(style):not(link)')) huskBlok.style.display = 'none';
    }
    box.dataset.placeret = '1';
    synlighed();
  }
  function omdirigerLinks() {
    document.querySelectorAll('.complementary-products__container').forEach(function (el) { if (el !== box) el.classList.remove('complementary-products__container'); });
    box.classList.add('complementary-products__container');
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', placer); } else { placer(); }
  // Temaets tilkøb kan blive hentet lidt senere – sørg for at links stadig rammer boksen
  window.addEventListener('load', function () { omdirigerLinks(); setTimeout(omdirigerLinks, 2000); });
  document.addEventListener('DOMContentLoaded', function () {
    var el = box.parentElement;
    while (el) {
      var c = getComputedStyle(el).backgroundColor;
      if (c && c !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(c)) { box.style.setProperty('--tk-bg', c); return; }
      el = el.parentElement;
    }
  });

  var norm = function (s) { return String(s || '').toLowerCase().replace(/\s+/g, ''); };
  // Bredde i cm fra fx "L220 x B100 x H74 cm", "B100 x L50 cm" eller "Ø120 x H74 cm"
  var bredde = function (s) { var m = String(s || '').match(/(?:B|Ø)\s*(\d+)/); return m ? m[1] : null; };
  // Tilkøbets bredde – eller den møbelbredde, det er lavet til, fx "B200 x H125 cm (til seng B180)" → 180
  var tilBredde = function (s) { var m = String(s || '').match(/til[^)]*?(?:B|Ø)\s*(\d+)/); return m ? m[1] : bredde(s); };
  // Alle bredder et tilkøb passer til, fx "B80/82 x H190 cm" → 80 og 82
  var bredder = function (s) {
    var t = String(s || ''), m = t.match(/til[^)]*?(?:B|Ø)\s*(\d+)/);
    if (m) return [m[1]];
    m = t.match(/(?:B|Ø)\s*(\d+)(?:\s*[\/-]\s*(\d+))?/);
    return m ? [m[1], m[2]].filter(Boolean) : [];
  };
  // Højde og længde i cm, fx "B82 x H190 cm" → 190, "L115 x B46 cm" → 115
  var hoejde = function (s) { var m = String(s || '').match(/H\s*(\d+)/); return m ? +m[1] : null; };
  var laengde = function (s) { var m = String(s || '').match(/L\s*(\d+)/); return m ? +m[1] : null; };
  // Stressless-størrelser: Small/Medium/Large → "Lænestol S/M" eller "Lænestol L"
  var STR = { small: 's', medium: 'm', large: 'l' };
  var moebel = { navne: [], valgt: [] };
  try { moebel = JSON.parse(box.querySelector('[data-tk-moebel]').textContent); } catch (e) {}
  var forms = box.querySelectorAll('[data-tk-form]');

  // Valg med andet navn på møblet end på tilkøbet (fx Farve på pladen = Træfarve i bordets tilvalg)
  var ALIAS = {
    'farve': ['farve', 'træfarve', 'bordpladefarve'],
    'træfarve': ['træfarve', 'stel', 'farve'],
    'størrelse': ['størrelse', 'størrelse stressless', 'model'],
    'model': ['model', 'størrelse']
  };

  // Alle kundens valg på møblet: varianter + tilvalg (properties[...], fx Træfarve hos Kristensen)
  var valg = {};
  function laesValg() {
    var m = {};
    moebel.navne.forEach(function (n, i) { m[n] = moebel.valgt[i]; });
    document.querySelectorAll('input[type=radio]:checked, select[name^="options"], select[name^="properties"]').forEach(function (el) {
      if (el.closest('[data-bh-tk]') || el.closest('[data-husk-ogsaa]')) return;
      var name = (el.name || '').toLowerCase().trim(), k = null, t;
      if ((t = name.match(/^properties\[(.+)\]$/))) k = t[1].trim();
      else if ((t = name.match(/^options\[(.+)\]$/))) k = t[1].trim();
      else moebel.navne.forEach(function (n) { if (name.indexOf(n) === 0) k = n; });
      if (k && el.value) m[k] = el.value;
    });
    valg = m;
  }
  laesValg();

  function moebelVaerdi(navn) {
    var navne = ALIAS[navn] || [navn];
    for (var i = 0; i < navne.length; i++) { if (valg[navne[i]]) return valg[navne[i]]; }
    return null;
  }

  function autoVaelg(form) {
    delete form.dataset.passerIkke;
    form.querySelectorAll('select[data-opt], select[data-prop]').forEach(function (s) {
      if (s.dataset.manuel === '1') return;
      var mv = moebelVaerdi(s.dataset.navn);
      var hit = '';
      if (mv) {
        Array.prototype.forEach.call(s.options, function (o) { if (o.value && norm(o.value) === norm(mv)) hit = o.value; });
        if (!hit) {
          var del = Array.prototype.filter.call(s.options, function (o) { return o.value && (norm(o.value).indexOf(norm(mv)) === 0 || norm(mv).indexOf(norm(o.value)) === 0); });
          if (del.length === 1) hit = del[0].value;
        }
        if (!hit && bredde(mv) && !form.hasAttribute('data-tk-frit')) {
          var kandidater = Array.prototype.filter.call(s.options, function (o) { return o.value && bredder(o.value).indexOf(bredde(mv)) !== -1; });
          // Ingen præcis bredde: tag den eneste, der er op til 10 cm bredere (fx gavl B146 til seng B140)
          if (!kandidater.length) kandidater = Array.prototype.filter.call(s.options, function (o) { var d = +tilBredde(o.value) - +bredde(mv); return o.value && tilBredde(o.value) && d > 0 && d <= 10; });
          // Flere i samme bredde: vælg den med samme højde (fx garderobeskab H190 → indbygningsdel H190)
          if (kandidater.length > 1 && hoejde(mv)) {
            var sammeH = kandidater.filter(function (o) { return hoejde(o.value) === hoejde(mv); });
            if (sammeH.length) kandidater = sammeH;
          }
          if (kandidater.length === 1) hit = kandidater[0].value;
          // Hynder o.l. er lidt mindre end møblet: tag den længde, der er op til 10 cm kortere (fx bænk L115 → hynde L110)
          if (!hit && laengde(mv)) {
            var kortere = Array.prototype.filter.call(s.options, function (o) { var d = laengde(mv) - laengde(o.value); return o.value && laengde(o.value) && d >= 0 && d <= 10; });
            if (kortere.length === 1) hit = kortere[0].value;
          }
          // Findes tilkøbet slet ikke i møblets bredde, passer det ikke og skjules (fx gavl uden B80 til seng i B80)
          var harBredder = Array.prototype.some.call(s.options, function (o) { return o.value && tilBredde(o.value); });
          if (!hit && harBredder && !kandidater.length) form.dataset.passerIkke = '1';
        }
      }
      if (!hit && mv && STR[String(mv).toLowerCase().trim()]) {
        // Small/Medium/Large → det valg, der nævner S, M eller L (fx forhøjelsesring "Lænestol S/M")
        var bog = STR[String(mv).toLowerCase().trim()];
        var str = Array.prototype.filter.call(s.options, function (o) { return o.value && new RegExp('(^|[\\s/])' + bog + '(?=$|[\\s/])', 'i').test(o.value); });
        if (str.length === 1) hit = str[0].value;
      }
      if (!hit && form.dataset.passerIkke !== '1') {
        // Et af møblets øvrige valg er præcis det samme (fx stellets "Matsort" → forhøjelseskit "Mat sort")
        var lige = Array.prototype.filter.call(s.options, function (o) {
          return o.value && Object.keys(valg).some(function (k) { return norm(valg[k]) === norm(o.value); });
        });
        if (lige.length === 1) hit = lige[0].value;
      }
      if (!hit && form.dataset.passerIkke !== '1') {
        // Valg som møblet ikke har (fx Materiale): brug møblets titel og øvrige valg,
        // fx "massiv plade" → "Massiv træ", "Sort linoleum" → "Linoleum"
        var tekst = ' ' + [moebel.titel || ''].concat(Object.keys(valg).map(function (k) { return valg[k]; })).join(' ').toLowerCase() + ' ';
        var ord = Array.prototype.filter.call(s.options, function (o) {
          var f = String(o.value || '').toLowerCase().split(/\s+/)[0];
          return o.value && f.length >= 4 && tekst.indexOf(' ' + f) !== -1;
        });
        if (ord.length === 1) hit = ord[0].value;
        // "B95 x L48 cm (passer til Ida 01 spisebord)" → vælg den, hvis modelnummeret står i møblets titel/valg
        if (!hit) {
          var passer = Array.prototype.filter.call(s.options, function (o) {
            var m = String(o.value || '').match(/passer til ([^)]+)/i);
            if (!m) return false;
            return m[1].toLowerCase().split(/[\s&,/]+/).some(function (w) { return /\d/.test(w) && tekst.indexOf(' ' + w + ' ') !== -1; });
          });
          if (passer.length === 1) hit = passer[0].value;
        }
      }
      if (hit) { s.value = hit; s.dataset.auto = '1'; }
      else if (s.dataset.auto === '1') { s.value = ''; delete s.dataset.auto; }
      // Forvalg på tilkøbet (fx "Massiv træ"): vælges på forhånd, men kunden kan stadig skifte
      if (!s.value && form.dataset.tkForvalg) {
        Array.prototype.forEach.call(s.options, function (o) { if (o.value && norm(o.value) === norm(form.dataset.tkForvalg)) s.value = o.value; });
      }
      if (s.options.length === 1) { s.value = s.options[0].value; }
    });
    udled(form);
  }

  // Er der kun én mulighed tilbage (ud fra de andre valg), vælges den automatisk.
  // Fx Skovby: bord i "Massiv træ" → tillægspladen findes kun i én bordplade-type i samme farve.
  function udled(form) {
    var data = form.querySelector('[data-tk-varianter]');
    if (!data) return;
    var vs; try { vs = JSON.parse(data.textContent); } catch (e) { return; }
    var sels = Array.prototype.slice.call(form.querySelectorAll('select[data-opt]'));
    var aendret = true;
    while (aendret) {
      aendret = false;
      sels.forEach(function (s) {
        if (s.value || s.dataset.manuel === '1') return;
        var i = +s.getAttribute('data-opt');
        var mulige = {};
        vs.forEach(function (v) {
          if (!v.a) return;
          var ok = sels.every(function (o) { var j = +o.getAttribute('data-opt'); return j === i || !o.value || v.o[j] === o.value; });
          if (ok) mulige[v.o[i]] = true;
        });
        var keys = Object.keys(mulige);
        if (keys.length === 1) { s.value = keys[0]; s.dataset.auto = '1'; aendret = true; }
      });
    }
  }

  function update(form) {
    var data = form.querySelector('[data-tk-varianter]');
    var vs = null;
    if (data) { try { vs = JSON.parse(data.textContent); } catch (e) { return; } }
    var valgt = [], mangler = false, auto = 0;
    form.querySelectorAll('select[data-opt]').forEach(function (s) {
      valgt[+s.getAttribute('data-opt')] = s.value;
      if (!s.value) mangler = true;
      var skjul = (s.dataset.auto === '1' && s.dataset.manuel !== '1') || s.options.length === 1;
      s.hidden = skjul;
      if (s.dataset.auto === '1' && s.dataset.manuel !== '1') auto++;
    });
    // Tilvalg (fx Stel/Træfarve på fodskamlen): følger møblet. Har møblet ikke valget, sendes det ikke med.
    form.querySelectorAll('select[data-prop]').forEach(function (s) {
      s.hidden = true;
      s.disabled = !s.value;
      if (s.dataset.auto === '1' && s.dataset.manuel !== '1') auto++;
    });
    if (!vs) {
      var m1 = form.closest('.bh-tk__vare').querySelector('[data-tk-match]');
      m1.hidden = auto === 0;
      m1.textContent = 'Matcher dit valg';
      return;
    }
    var v = null;
    if (!mangler) {
      for (var i = 0; i < vs.length; i++) {
        var ok = true;
        for (var j = 0; j < vs[i].o.length; j++) { if (vs[i].o[j] !== valgt[j]) { ok = false; break; } }
        if (ok) { v = vs[i]; break; }
      }
    }
    var vare = form.closest('.bh-tk__vare');
    var match = vare.querySelector('[data-tk-match]');
    match.hidden = auto === 0 || mangler;
    match.textContent = 'Matcher dit valg';
    var btn = form.querySelector('button');
    var idIn = form.querySelector('input[name="id"]');
    var pris = vare.querySelector('[data-tk-pris]');
    if (v && v.a) {
      idIn.value = v.id; btn.disabled = false; btn.textContent = 'Tilføj';
      if (pris) {
        pris.textContent = '';
        if (v.c) {
          var f = document.createElement('s'); f.className = 'bh-tk__foer'; f.textContent = v.c;
          var t = document.createElement('span'); t.className = 'bh-tk__tilbud'; t.textContent = v.p;
          pris.appendChild(f); pris.appendChild(document.createTextNode(' ')); pris.appendChild(t);
        } else { pris.textContent = v.p; }
      }
    } else {
      idIn.value = ''; btn.disabled = !mangler;
      btn.textContent = mangler ? 'Tilføj' : 'Udsolgt';
    }
  }

  function opdaterAlle() { forms.forEach(function (f) { autoVaelg(f); update(f); }); synlighed(); }

  // Viser kun tilkøb, der passer til møblet: de første 3 + "Vis alle"-knap. Passer intet, skjules Tilkøb-delen.
  var udvidet = false;
  function synlighed() {
    var items = Array.prototype.slice.call(box.querySelectorAll('.bh-tk__vare'));
    // Har kunden valgt "Uden udtræk" på bordet, skjules tillægsplader og udtræksskjuler
    var v0 = valg || {};
    var udenUdtraek = Object.keys(v0).some(function (k) { return /^uden udtræk/i.test(String(v0[k] || '').trim()); });
    var ok = items.filter(function (li) {
      var f = li.querySelector('[data-tk-form]');
      if (f && f.dataset.passerIkke === '1') return false;
      var navn = (li.querySelector('.bh-tk__navn') || {}).textContent || '';
      return !(udenUdtraek && /tillægsplade|udtræksskjuler/i.test(navn));
    });
    items.forEach(function (li) { li.classList.toggle('bh-tk__vare--skjult', ok.indexOf(li) === -1); });
    ok.forEach(function (li, i) { li.hidden = !udvidet && i >= 3; });
    var flere = box.querySelector('[data-tk-flere]');
    if (flere) { flere.hidden = udvidet || ok.length <= 3; flere.textContent = 'Vis alle tilkøb (' + ok.length + ')'; }
    box.classList.toggle('bh-tk--tom', ok.length === 0);
    if (box.dataset.placeret) box.hidden = ok.length === 0 && !box.querySelector('[data-husk-ogsaa]');
  }

  forms.forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (!e.target.matches('select[data-opt], select[data-prop]')) return;
      e.target.dataset.manuel = '1';
      e.target.classList.remove('bh-tk__select--fejl');
      update(form);
    });
  });
  // Mangler kunden et valg, vises rullemenuen i stedet for at sende formularen.
  // (capture, så det sker før temaets product-form lægger i kurven)
  function manglerValg(form, e) {
    var idIn = form.querySelector('input[name="id"]');
    if (idIn && idIn.value) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var tom = Array.prototype.find.call(form.querySelectorAll('select[data-opt]'), function (s) { return !s.value; });
    if (tom) { tom.hidden = false; tom.classList.add('bh-tk__select--fejl'); tom.focus(); }
  }
  // Knappen er type="button", så temaets konfigurator ikke stopper klikket (den fanger alle submit-knapper).
  // Formularen sendes via temaets product-form, så kurven åbner som ved "Læg i kurv".
  box.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bh-tk__knap');
    var form = btn && btn.closest('[data-tk-form]');
    if (!form || btn.disabled) return;
    e.preventDefault();
    var idIn = form.querySelector('input[name="id"]');
    if (idIn && idIn.value) { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); return; }
    manglerValg(form, e);
  }, true);
  box.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('[data-tk-form]')) manglerValg(form, e);
  }, true);
  opdaterAlle();

  var flere = box.querySelector('[data-tk-flere]');
  if (flere) flere.addEventListener('click', function () { udvidet = true; synlighed(); });

  // Følg med, når kunden skifter variant eller tilvalg på møblet
  var sidst = JSON.stringify(valg);
  function genlaes() {
    laesValg();
    var ny = JSON.stringify(valg);
    if (ny === sidst) return;
    sidst = ny;
    opdaterAlle();
  }
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    var arr = v && (v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }));
    if (arr && arr.length) moebel.valgt = arr;
    setTimeout(genlaes, 0);
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-bh-tk]')) return;
    setTimeout(genlaes, 80);
  });
})();
